'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Api = undefined;

var _api = require('./api');

exports.Api = _api.Api; // @ts-check